import { render, staticRenderFns } from "./HandleCherge.vue?vue&type=template&id=d5130698&"
import script from "./HandleCherge.vue?vue&type=script&lang=js&"
export * from "./HandleCherge.vue?vue&type=script&lang=js&"
import style0 from "./HandleCherge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HandleCherge.vue"
export default component.exports